import React from "react";
import {
  FaLocationDot,
  FaClock,
  FaInstagram,
} from "react-icons/fa6";

const countryCodes = [
  { code: "+1", country: "USA / Canada" },
  { code: "+44", country: "UK" },
  { code: "+65", country: "Singapore" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+971", country: "UAE" },
  { code: "+86", country: "China" },
];

export default function ContactSection({ language = "EN" }) {

  const lang = language === "CN" ? "zh" : "en";

  const text = {

    en: {
      title: "Send us a message",
      subtitle: "We’d be happy to assist with your enquiry",

      name: "Full Name",
      email: "Email Address",
      phone: "Contact Number",
      interest: "I am interested in...",
      hear: "How did you hear about us?",
      message: "Message",
      send: "Send Message",

      note:
        "We typically respond within one business day. All enquiries are handled with complete confidentiality.",

      office: "Our Office",
      hours: "Opening Hours",
      follow: "Follow Our Journey",

      address: "371 Alexandra Road, #05-11, Singapore",
      time: "Mon–Fri 9am–6pm",

      interestList: [
        "Life Insurance",
        "Health Insurance",
        "Wealth & Investments",
        "Legacy Planning",
        "High-Net-Worth Advisory",
        "Group Insurance",
        "Careers",
        "General Enquiry",
      ],

      hearList: [
        "Referral",
        "Social Media",
        "Search Engine",
        "Event",
        "Other",
      ],
    },

    zh: {
      title: "发送消息",
      subtitle: "我们很乐意为您提供帮助",

      name: "姓名",
      email: "邮箱",
      phone: "联系电话",
      interest: "我感兴趣的是",
      hear: "您如何知道我们",
      message: "留言",
      send: "发送",

      note:
        "我们通常在一个工作日内回复，所有咨询均保密",

      office: "我们的办公室 ",
      hours: "营业时间",
      follow: "关注我们",

      address: "新加坡亚历山大路371号 #05-11",
      time: "周一至周五 9:00am – 6:00pm",

      interestList: [
        "人寿保险",
        "健康保险",
        "财富管理",
        "传承规划",
        "高净值服务",
        "团体保险",
        "加入我们",
        "其他咨询",
      ],

      hearList: [
        "推荐",
        "社交媒体",
        "搜索引擎",
        "活动",
        "其他",
      ],
    },

  };


  return (
    <div className="w-full bg-white">

      {/* FORM */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="grid lg:grid-cols-2 overflow-hidden shadow-lg">

          {/* LEFT */}
          <div className="bg-[#c09f7c33] p-4 sm:p-6">

            <h2 className="text-2xl font-bold text-[#154059] mb-2">
              {text[lang].title}
            </h2>

            <p className="text-[#9c9997] mb-6 text-sm">
              {text[lang].subtitle}
            </p>

<form className="space-y-3 sm:space-y-4">

  <input
    type="text"
    placeholder={text[lang].name}
    className="w-full border px-5 py-3"
    required
  />

  <input
    type="email"
    placeholder={text[lang].email}
    className="w-full border px-5 py-3"
    required
  />

  {/* phone */}
  <div className="flex flex-col sm:flex-row gap-3">

    <div className="relative w-full sm:w-auto">
      <select
        className="border px-3 py-3 pr-8 w-full appearance-none"
        required
      >
        {countryCodes.map((c, i) => (
          <option key={i}>
            {c.code} {c.country}
          </option>
        ))}
      </select>

      {/* Arrow */}
      <svg
        className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <input
      type="tel"
      placeholder={text[lang].phone}
      className="w-full border px-5 py-3"
      required
    />

  </div>

  {/* interest */}
  <div className="relative">

    <select
      className="w-full border px-5 py-3 pr-10 appearance-none"
      required
    >
      <option value="">
        {text[lang].interest}
      </option>

      {text[lang].interestList.map((i, idx) => (
        <option key={idx} value={i}>
          {i}
        </option>
      ))}
    </select>

    {/* Arrow */}
    <svg
      className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>

  </div>

  {/* hear */}
  <div className="relative">

    <select
      className="w-full border px-5 py-3 pr-10 appearance-none"
      required
    >
      <option value="">
        {text[lang].hear}
      </option>

      {text[lang].hearList.map((i, idx) => (
        <option key={idx} value={i}>
          {i}
        </option>
      ))}
    </select>

    {/* Arrow */}
    <svg
      className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>

  </div>

  <textarea
    rows="4"
    placeholder={text[lang].message}
    className="w-full border px-5 py-3"
    required
  />

  <button className="w-full bg-[#C09F7C] text-white py-3">
    {text[lang].send}
  </button>

  <p className="text-xs text-[#9c9997]">
    {text[lang].note}
  </p>

</form>
          </div>


          {/* IMAGE */}
          <img
            src="/assets/images/high-angle-woman-working-laptop.jpg"
            className="w-full h-60 sm:h-full object-cover"
          />

        </div>

      </div>


      {/* INFO */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">

        <div className="grid md:grid-cols-3 gap-10">

          <Info
            icon={<FaLocationDot />}
            title={text[lang].office}
            text={text[lang].address}
          />

          <Info
            icon={<FaClock />}
            title={text[lang].hours}
            text={text[lang].time}
          />

          <Info
            icon={<FaInstagram />}
            title={text[lang].follow}
            text="@jtgroup_gaby | @gabygroup_"
          />

        </div>

      </div>

    </div>
  );
}



function Info({ icon, title, text }) {

  return (

    <div className="flex gap-4">

      <div className="w-12 h-12 bg-[#C09F7C] text-white flex items-center justify-center rounded-full">
        {icon}
      </div>

      <div>

        <h5 className="font-semibold text-[#154059]">
          {title}
        </h5>

        <p className="text-sm text-gray-500">
          {text}
        </p>

      </div>

    </div>

  );

}